import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingLayout } from '../components/layout/OnboardingLayout'
import ScheduleVisitStep from '../components/onboarding/steps/ScheduleVisitStep'
import { authService } from '../services/authService'

const ScheduleVisitPage: React.FC = () => {
  const navigate = useNavigate()
  const hasCompletedRef = useRef(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const progressUpdatedRef = useRef(false) // Nuevo ref para rastrear si se actualizó correctamente

  const [personType, setPersonType] = React.useState<string | null>(null)

  useEffect(() => {
    const getPersonTypeFromStorage = () => {
      try {
        const userData = localStorage.getItem('user_data') // Corregida la clave
        console.log('📦 Raw userData from localStorage:', userData)
        if (userData) {
          const user = JSON.parse(userData)
          console.log('👤 Parsed user object:', user)
          console.log('🏷️ PersonType from user:', user.personType)
          return user.personType
        }
        return null
      } catch (error) {
        console.error('Error al obtener personType:', error)
        return null
      }
    }

    const personType = getPersonTypeFromStorage()

    setPersonType(personType)
  }, [])

  // Limpiar timeout al desmontar el componente
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  let steps = [
    { id: '1', title: '', description: '', status: 'completed' as const },
    { id: '2', title: '', description: '', status: 'completed' as const },
    { id: '3', title: '', description: '', status: 'completed' as const },
    { id: '4', title: '', description: '', status: 'completed' as const },
    { id: '5', title: '', description: '', status: 'completed' as const },
    { id: '6', title: '', description: '', status: 'current' as const },
  ]

  if (personType === 'PFAE') {
    steps = [
      { id: '1', title: '', description: '', status: 'completed' as const },
      { id: '2', title: '', description: '', status: 'completed' as const },
      { id: '3', title: '', description: '', status: 'completed' as const },
      { id: '4', title: '', description: '', status: 'completed' as const },
      { id: '5', title: '', description: '', status: 'current' as const },
    ]
  }

  const handleComplete = async (stepData: any) => {
    // Si ya se ejecutó una vez, no hacer nada
    if (hasCompletedRef.current) {
      console.log('⚠️ handleComplete already executed, skipping...')
      return
    }

    // Marcar como ejecutado
    hasCompletedRef.current = true

    console.log('Schedule visit completed:', stepData)

    const nextUrl = '/onboarding/finished'

    // Actualizar progressURL en credit-application después del éxito
    try {
      console.log(
        '📍 Updating progressURL after successful visit scheduling...'
      )
      const creditAppId = await authService.getCurrentCreditApplicationId()

      if (creditAppId) {
        await authService.updateCreditApplicationProgress(creditAppId, nextUrl)
        progressUpdatedRef.current = true // Marcar como actualizado exitosamente
        console.log('✅ ProgressURL updated successfully to:', nextUrl)
      } else {
        console.warn(
          '⚠️ No credit application ID found, skipping progressURL update'
        )
        // No marcar como exitoso si no hay creditAppId
      }
    } catch (progressError) {
      console.error('❌ Error updating progressURL:', progressError)
      progressUpdatedRef.current = false // Marcar como fallido
      // No detener el flujo si falla la actualización del progreso
    }

    // Guardar referencia del timeout para poder cancelarlo
    timeoutRef.current = setTimeout(() => {
      navigate(nextUrl)
    }, 20000)
  }

  // Función para navegación inmediata (solo si la actualización fue exitosa)
  const navigateImmediately = () => {
    if (!progressUpdatedRef.current) {
      console.warn(
        '⚠️ Cannot navigate immediately: progress not updated successfully'
      )
      return
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    console.log('✅ Navigating immediately after successful progress update')
    navigate('/onboarding/finished')
  }

  return (
    <OnboardingLayout steps={steps}>
      <ScheduleVisitStep
        onComplete={handleComplete}
        onNavigateImmediately={navigateImmediately} // Pasar la función si es necesaria
      />
    </OnboardingLayout>
  )
}

export default ScheduleVisitPage
